import type { RouteRecordRaw } from 'vue-router';
import { FeatureFlags } from '@/types/featureFlags';

const routes: RouteRecordRaw[] = [
  {
    path: '/agents',
    name: 'Agents',
    component: () => import('@/views/AgentsPage.vue'),
    redirect: { name: 'MyAgents' },
    meta: {
      layout: 'LayoutAuthenticated',
      requiresAuth: true,
      requiredLDFlags: [FeatureFlags.AGENTS_ENABLED],
    },
    children: [
      {
        path: '',
        name: 'MyAgents',
        component: () => import('@/views/AgentsView.vue'),
      },
      {
        path: 'directory',
        name: 'AgentDirectory',
        component: () => import('@/views/AgentDirectoryView.vue'),
        meta: {
          layout: 'LayoutAuthenticated',
          requiresAuth: true,
          requiredLDFlags: [FeatureFlags.AGENTS_ENABLED, FeatureFlags.AGENT_DIRECTORY_ENABLED],
        },
      },
    ],
  },
];

export default routes;
